"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsActionType = exports.AnalyticsEventNames = void 0;
var AnalyticsEventNames;
(function (AnalyticsEventNames) {
    AnalyticsEventNames["PROCESS_ACTIVATION"] = "process.activation";
    AnalyticsEventNames["PROCESS_ADD_PROPERTY"] = "process.addaproperty";
    AnalyticsEventNames["PROCESS_ADD_FUEL"] = "process.addafuel";
    AnalyticsEventNames["PROCESS_LOGIN"] = "process.login";
    AnalyticsEventNames["PROCESS_OVERVIEW"] = "process.overview";
    AnalyticsEventNames["PROCESS_PAYMENT"] = "process.payment";
    AnalyticsEventNames["PROCESS_BILLS"] = "process.bills";
    AnalyticsEventNames["PROCESS_SETTINGS"] = "process.settings";
    AnalyticsEventNames["PROCESS_LOGOUT"] = "process.logout";
    AnalyticsEventNames["PROCESS_REWARDS"] = "process.rewards";
    AnalyticsEventNames["PROCESS_USAGE"] = "process.usage";
    AnalyticsEventNames["PROCESS_RETRIEVE_LOGIN_EMAIL"] = "process.retrieveLoginEmail";
    AnalyticsEventNames["PROCESS_RESET_PASSWORD"] = "process.resetPassword";
    AnalyticsEventNames["PROCESS_DIRECT_DEBIT"] = "process.directDebit";
    AnalyticsEventNames["PROCESS_DIRECT_DEBIT_V2"] = "process.directdebit";
    AnalyticsEventNames["PROCESS_PAYMENTEXTENSION"] = "process.paymentextension";
    AnalyticsEventNames["PROCESS_ACCOUNT_SELECTION"] = "process.accountselection";
    AnalyticsEventNames["PROCESS_VIEW_PLAN"] = "process.viewplan";
    AnalyticsEventNames["PROCESS_AUTOREGISTRATION"] = "process.autoregistration";
})(AnalyticsEventNames = exports.AnalyticsEventNames || (exports.AnalyticsEventNames = {}));
var AnalyticsActionType;
(function (AnalyticsActionType) {
    AnalyticsActionType["LOAD"] = "Load";
    AnalyticsActionType["CLICK"] = "Click";
    AnalyticsActionType["ERROR"] = "Error";
    AnalyticsActionType["SUCCESS"] = "Success";
})(AnalyticsActionType = exports.AnalyticsActionType || (exports.AnalyticsActionType = {}));
//# sourceMappingURL=analytics.js.map